import { Fragment } from 'react';
import c from './category-filters.module.scss';
import { Checkbox } from '@monash/portal-react';

const CategoryFilters = ({ options, value: valueProp, onChange }) => {
  const handleCheck = (optionValue, e) => {
    const checked = e.target.checked;
    const newValue = checked
      ? [...valueProp, optionValue]
      : valueProp.filter((v) => v !== optionValue);
    onChange(newValue);
  };

  return options.map((option) => {
    const { value, text, subOptions } = option;
    const hasSubOptions = Boolean(subOptions);

    return (
      <Fragment key={value}>
        <Checkbox
          on={valueProp?.includes(value)}
          onChange={(e) => handleCheck(value, e)}
          text={text}
        />
        {hasSubOptions && (
          <div className={c.subOptionsContainer}>
            {subOptions.map((subOpt) => {
              const { value: subOptValue, text: subOptText } = subOpt;

              return (
                <Checkbox
                  key={subOptValue}
                  on={valueProp?.includes(subOptValue)}
                  onChange={(e) => handleCheck(subOptValue, e)}
                  text={subOptText}
                />
              );
            })}
          </div>
        )}
      </Fragment>
    );
  });
};

export default CategoryFilters;
